//@ts-check

if (!PretorCDNAddress) {
    //replace starts here
    var PretorCDNAddress = 'https://ptgweblivestaging.pretor.co.za:444/';
    //replace ends here
    //DO NOT DELETE THE ABOVE COMMENTS - ITS BEING USED BY THE BUILD STEP!!!
}

class UtilityService {
    constructor($http, $timeout, $location, PretorCache, LocalStorageService, InternalLinksService) {
        this.$http = $http;
        this.$timeout = $timeout;
        this.$location = $location;
        this.PretorCache = PretorCache;
        this.LocalStorageService = LocalStorageService;
        this.InternalLinksService = InternalLinksService;

        this.init();
    }

    init() {
        this.apiRetry = {
            units: 'ms',
            value: 1800
        };
        this.dateTimeFormat = 'DD MMM YYYY HH:mm:ss A';

        this.loadingImage =
            (_.endsWith(PretorCDNAddress, '/') ? PretorCDNAddress : PretorCDNAddress + '/') + 'images/pretor.gif';

        this.loadingDocumentImage =
            (_.endsWith(PretorCDNAddress, '/') ? PretorCDNAddress : PretorCDNAddress + '/') + 'images/loading doc.gif';

        this.largePretorLogo =
            (_.endsWith(PretorCDNAddress, '/') ? PretorCDNAddress : PretorCDNAddress + '/') +
            'images/email/pretor_group_logo.png';

        this.smallPretorLogo =
            (_.endsWith(PretorCDNAddress, '/') ? PretorCDNAddress : PretorCDNAddress + '/') +
            'images/logo_pretor.png';
    }

    QueryString(queryStringName) {
        let url = this.$location.absUrl().toLowerCase();
        let name = queryStringName.toLowerCase().replace(/[\[\]]/g, '\\$&');

        if (!url) {
            url = this.$location.absUrl().toLowerCase();
        }

        const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
            results = regex.exec(url);

        if (!results) return null;

        if (!results[2]) return '';

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    buildingRefsAreEqual(newValue, oldValue) {
        let oldRef = oldValue;
        let newRef = newValue;
        if (!!oldRef && typeof oldRef === 'object') {
            oldRef = oldRef.SchemeReference.toLowerCase().trim();
        }

        if (!!newRef && typeof newRef === 'object') {
            newRef = newRef.SchemeReference.toLowerCase().trim();
        }
        const results = oldRef === newRef;

        return results;
    }

    buildingRefSameAsOld(newRef) {
        let oldRef = this.LocalStorageService.retrieve('selectedBuildingRef');
        if (typeof oldRef === 'object') {
            oldRef = oldRef.SchemeReference.toLowerCase().trim();
        }

        if (typeof newRef === 'object') {
            newRef = newRef.SchemeReference.toLowerCase().trim();
        }
        const results = oldRef === newRef;

        return results;
    }

    async loadLoader() {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            const url = PretorCDNAddress.endsWith('/') ? PretorCDNAddress : `${PretorCDNAddress}/'images/pretor.gif`;

            const results = await this.$http.get(url, { cache: this.PretorCache });
            this.$timeout(() => promiseHandler.resolve(results));
        } catch (err) {
            console.error('Pretor Loader could not be cached :(');
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async checkIfFileExists(fileUrl) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = this.InternalLinksService.getLink('CheckIfFileExists');

            if (!url) {
                this.InternalLinksService.getLinks('/api/documents/links');
                url = this.InternalLinksService.getLink('CheckIfFileExists');
            }

            const headers = this.headersWithContentType;
            const results = await this.$http.post(url, { fileUrl: fileUrl }, { headers });
            this.$timeout(() => promiseHandler.resolve(results.data));
        } catch (err) {
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    getFormatedDate(date, isString) {
        const momentDate = isString ? moment(date, 'MM-DD-YYYY') : moment(date);
        const formatedDateString = momentDate.format('MM-DD-YYYY');
        const formatedDate = moment(formatedDateString, 'MM-DD-YYYY').add(3, 'h').toDate();

        return formatedDate;
    }

    hasQueryString(queryString) {
        queryString = queryString.toLowerCase().trim();
        const foundQueryString = this.QueryString(queryString);

        return foundQueryString;
    }

    generateDocumentUrl(guid, ext) {
        const baseAddress = `${pretorOnlineUrl}${pretorOnlineUrl.endsWith('/') ? '' : '/'}`;
        const url = `${baseAddress}documents/byId/${guid}${ext || ''}/?handleNotFound=false`;

        return url;
    }

    safeApply(scope, fn) {
        return scope.$$phase || scope.$root.$$phase ? fn() : scope.$apply(fn);
    }

    mapForClient(original) {
        const transformed = {};

        if (!original) {
            return null;
        }

        Object.keys(original).map((key) => {
            const newKey = `${key.substr(0, 1).toLowerCase()}${key.substr(1)}`;
            transformed[newKey] = original[key];
        });

        return transformed;
    }

    mapForServer(original) {
        const transformed = {};

        if (!original) {
            return null;
        }

        Object.keys(original).map((key) => {
            const newKey = `${key.substr(0, 1).toUpperCase()}${key.substr(1)}`;
            transformed[newKey] = original[key];
        });

        return transformed;
    }

    get headersWithContentType() {

        const headers = this.headers;
        return {
            ...headers,
            'content-type': 'application/json'
        };
    }

    get basicHeaders() {
        return {
            'content-type': 'application/json'
        };
    }

    get headers() {
        const userProfile = this.LocalStorageService.retrieve('userProfile');
        const userSession = this.LocalStorageService.retrieve('userSession');

        if (!!!userSession) {
            throw `Could not retrieve 'sessionToken' and\or 'userName' to send as the HTTP Headers`;
        }

        const sessionToken = userSession.SessionToken;
        const userName = userProfile.UserName || userProfile.WebUsername;

        if (!(sessionToken && sessionToken.length > 2) || !(userName && userName.length > 2)) {
            throw `Could not retrieve 'sessionToken' and\or 'userName' to send as the HTTP Headers`;
        }

        const headers = {
            userName,
            sessionToken
        };

        return headers;
    }

    get selectedBuildingRef() {
        let selectedBuilding;

        const selectedRef = this.LocalStorageService.retrieve('selectedBuildingRef');
        if (typeof selectedRef === 'object') {
            selectedBuilding = selectedRef.SchemeReference.trim();
        } else {
            selectedBuilding = selectedRef.trim();
        }
        if (!selectedBuilding) {
            let selectedBuildingRefQueryString = this.QueryString('DBRef');
            if (selectedBuildingRefQueryString) {
                this.selectedBuilding = selectedBuildingRefQueryString.toUpperCase();
            }
        }

        return selectedBuilding;
    }
}

export default /* @ngInject */ ($http, $timeout, $location, PretorCache, LocalStorageService, InternalLinksService) =>
    new UtilityService($http, $timeout, $location, PretorCache, LocalStorageService, InternalLinksService);
